// 🎬🍿 09-23 movie-night batch 1: THE SWITCH MODULE (MOVIE_NIGHT_UX_HANDOFF
// §3.10). Every flagless frontend wave of the batch has an OFF switch here, so
// a piece can be put back without a Lambda flip: each is a build-time boolean
// and each `false` restores byte-identical output for that piece (the page
// reads the switch at the mount and renders exactly what it rendered before).
// Nina's rulings 7 / 8 / 9-10 / 12-14 / 16 / 17 are the defaults below.

// ⏳ §3.1 the countdown to the top. false = the strip stays the composer's own
// line (HumanInputForm) and nothing mounts at the top of the page.
export const TOP_CLOCK = true;

// 🪧 §3.2 the plate fold + auto-fold. false = the plate never folds, no arrow,
// no sessionStorage plateFold key, today's row at all times.
export const PLATE_FOLD = true;

// 🚪 §3.3 Go opens the picture. false = the strip's Go seats / moves you
// directly as today (no peek opens, no "← Back to chat" pill).
export const PEEK_STAGE = true;

// 🛋️ §3.4 v2 the couch column. false = quips stay overlay-only inside the video
// (no couchLog, no CouchColumn mount, no couch input).
export const COUCH = true;

// 🤫 §3.6 aux duck. false = the viewer's music bed plays at full volume through
// a screening (the backend quiet-house flag is separate and unaffected).
export const AUX_DUCK = true;

// 🎞️ §3.5 the projector layer + ⛶ big screen (week two). false = the film
// stays in the theater / TV place, nothing paints over the painted screen.
export const PROJECTOR = false;

// A frozen readout for a debug line or a smoke ("which switches is this
// bundle carrying?"). Keep it in step with the exports above.
export const SWITCHES = Object.freeze({ TOP_CLOCK, PLATE_FOLD, PEEK_STAGE, COUCH, AUX_DUCK, PROJECTOR });
